














import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import EpisodeBody from '@/views/templates/kuntama/parts/EpisodeBody.vue'

export default
  components: {
    EpisodeTitle
    EpisodeBody
  }

  data: () ->
    text: [
      '福虎の燻製たまごは、素材の良さを活かしながら、旨みを引き出していく、昔ながらの伝統製法を守り続けています。'
      'だしが入った石窯にたまごを2日間漬け込み、その後、燻製窯へ。低温の燻煙をじっくり6日間かけ流し、仕上がった燻製たまごは、つややかに色づき、白身と黄身のバランスも絶妙。黄身の深部までしっかりスモークされた燻製たまごは、香り高く、濃厚な味わいをお楽しみいただけます。'
      '燻製たまごづくりは、1日12時間かけて、ゆっくりじっくり燻す繊細な製法がゆえ、気を休めることができません。<br><span class="red">それでも心を込めて作り上げた商品を「見て楽しみ、香りで楽しみ、食べて楽しんでほしい」との想いから、お父さんは日々煙と向き合って</span>います。'
    ]
